import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AllTrailersComponent } from './all-trailers/all-trailers.component';
import { AssetPickupQueueComponent } from './asset-pickup-queue/asset-pickup-queue.component';
import { AutoDispatchStatsComponent } from './auto-dispatch-stats/auto-dispatch-stats.component';
import { BolOcrAuditContainerComponent } from './bol-ocr-audit/bol-ocr-audit-container/bol-ocr-audit-container.component';
import { BolOcrAuditOrderComponent } from './bol-ocr-audit/bol-ocr-audit-order/bol-ocr-audit-order.component';
import { BolOcrAuditComponent } from './bol-ocr-audit/bol-ocr-audit.component';
import { CarrierCommitmentsComponent } from './carrier-commitments/carrier-commitments.component';
import { CompanyTrailersComponent } from './company-trailers/company-trailers.component';
import { CreateDemandSnapshotComponent } from './create-demand-snapshot/create-demand-snapshot.component';
import { FiveFTourInternalDashboardComponent } from './fivef-tour-internal-dashboard/fivef-tour-internal-dashboard.component';
import { HoneyMapComponent } from './honey-map/honey-map.component';
import { InternalDashboardComponent } from './internal-dashboard/internal-dashboard.component';
import { MineQrGeneratorComponent } from './mine-qr-generator/mine-qr-generator.component';
import { OmmaContainerComponent } from './omma-upload/omma-container/omma-container.component';
import { UploadPropxComponent } from './omma-upload/upload-propx/upload-propx.component';
import { RevenueAllocationDashboardComponent } from './revenue-allocation-dashboard/revenue-allocation-dashboard.component';
import { ShiftDailyCapComponent } from './shift-daily-cap/shift-daily-cap.component';
import { ShiftTimelineComponent } from './shift-timeline/shift-timeline.component';
import { ShiftToolComponent } from './shift-tool/shift-tool.component';

const routes: Routes = [
  {
    path: 'dashboard',
    component: InternalDashboardComponent,
  },
  {
    path: 'shift_inspector',
    component: ShiftTimelineComponent,
  },
  {
    path: 'revenue_allocation',
    component: RevenueAllocationDashboardComponent,
  },
  {
    path: 'auto_dispatch_stats',
    component: AutoDispatchStatsComponent,
  },
  {
    path: 'capacity_management',
    component: CarrierCommitmentsComponent,
  },
  {
    path: 'shift_tool',
    component: ShiftToolComponent,
  },
  {
    path: 'honey_map',
    component: HoneyMapComponent,
  },
  {
    path: 'company_trailers',
    component: CompanyTrailersComponent,
  },
  {
    path: 'all_trailers',
    component: AllTrailersComponent,
  },
  {
    path: 'asset_pickup_queue',
    component: AssetPickupQueueComponent,
  },
  {
    path: 'create-demand-snapshot',
    component: CreateDemandSnapshotComponent,
  },
  {
    path: 'omma',
    component: OmmaContainerComponent,
    children: [
      {
        path: 'propx',
        component: UploadPropxComponent,
        data: { uploadType: 'propx' },
      },
      {
        path: 'sandi',
        component: UploadPropxComponent,
        data: { uploadType: 'sandi' },
      },
      {
        path: 'eog',
        component: UploadPropxComponent,
        data: { uploadType: 'eog' },
      },
      {
        path: 'solaris',
        component: UploadPropxComponent,
        data: { uploadType: 'solaris' },
      },
      {
        path: 'cig',
        component: UploadPropxComponent,
        data: { uploadType: 'cig' },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'propx',
      },
    ],
  },
  {
    path: 'bolocr/list',
    component: BolOcrAuditContainerComponent,
    children: [
      {
        path: 'all',
        component: BolOcrAuditComponent,
        data: { bolList: 'all' },
      },
      {
        path: 'failed',
        component: BolOcrAuditComponent,
        data: { bolList: 'failed' },
      },
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'all',
      },
    ],
  },
  {
    path: 'bolocr/order/:bolocrOrderId',
    component: BolOcrAuditOrderComponent,
  },
  {
    path: 'shift_daily_cap',
    component: ShiftDailyCapComponent,
  },
  {
    loadChildren: () => import('src/app/internal/dispatch/dispatch.module').then((m) => m.DispatchModule),
    path: 'dispatch',
  },
  {
    loadChildren: () =>
      import('src/app/internal/experience-manager/experience-manager.module').then((m) => m.ExperienceManagerModule),
    path: 'experience',
  },
  {
    loadChildren: () => import('src/app/internal/lane-tool/lane-tool.module').then((m) => m.LaneToolModule),
    path: 'lane-tool',
  },
  {
    loadChildren: () => import('src/app/internal/load-count/load-count.module').then((m) => m.LoadCountModule),
    path: 'load_count',
  },
  {
    loadChildren: () => import('src/app/internal/demand-import/demand-import.module').then((m) => m.DemandImportModule),
    path: 'demand_import',
  },
  {
    loadChildren: () =>
      import('src/app/internal/supply-forecast/supply-forecast.module').then((m) => m.SupplyForecastModule),
    path: 'supply_forecast',
  },
  {
    loadChildren: () => import('src/app/internal/lohi-loop/lohi-loop.module').then((m) => m.LohiLoopModule),
    path: 'lohi_loop',
  },
  {
    loadChildren: () =>
      import('src/app/internal/regional-dashboard/regional-dashboard.module').then((m) => m.RegionalDashboardModule),
    path: 'regional_dashboard',
  },
  {
    loadChildren: () => import('src/app/internal/ops-billing/ops-billing.module').then((m) => m.OpsBillingModule),
    path: 'ops_billing',
  },
  {
    path: 'tour_dashboard',
    component: FiveFTourInternalDashboardComponent,
  },
  {
    path: 'mine_qr',
    component: MineQrGeneratorComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InternalRoutingModule {}
